export enum ApiRoutesOrders {
  Orders = "admin/orders",
  AllOrders = "admin/orders/all",
  AllOrdersLocations = "general/delivery-zones/all",
  OrderDetails = "admin/orders/details",
  AssignDriver = "assign-driver",
  AssignDeliveryCompany = "assign-company",
  CancelOrder = "/admin/orders/cancel",
  MarkExpeditionAsDelivered = "/admin/orders/mark-expedition-as-delivered",
  OrdersFilterLimits = "/admin/orders/min-and-max-total",
  OrderNotesForAdmin = "/admin/orders/problem-notes"
}

export enum OrderUnpackingStatus {
  WaitingToReschedule = "WaitingToReschedule",
  WaitingToUnpack = "WaitingToUnpack",
  Unpacked = "Unpacked"
}

export enum ProblemNotesForAdmin {
  ResellerReachedMaxConsecutiveNumberOfFailedOrders = "ResellerReachedMaxConsecutiveNumberOfFailedOrders"
}

/**
 * Outcome of a manual confirmation call recorded by an agent. Informative
 * only — it does not change the order's status.
 */
export enum OrderCallConfirmationResult {
  Confirmed = "Confirmed",
  Unreachable = "Unreachable",
  Cancelled = "Cancelled"
}

export * from "./orderStatus";
export * from "./orderPaymentMethod";
export * from "./orderMode";
export * from "./orderType";
export * from "./expeditionConfirmationSource";
